import { useHubble } from '@seek/hubble';
import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Box, Column, Columns, Stack, Text } from 'braid-design-system';

import { useAppConfig } from '../../../modules/appConfig';
import { PEOPLE_SEARCH } from '../../Router';

import translations from './.vocab';
import { CandidatesSVG } from './CandidatesSVG.tsx';

export const PeopleSearch = () => {
  const { t } = useTranslations(translations);
  const hubble = useHubble();
  const { zone, language } = useAppConfig();
  const peopleSearchUrl = useMelwaysLink({
    path: '/profiles/search?tracking=ILC-profileSearch-profileMain',
  });

  const trackPeopleSearchClick = () => {
    hubble.trackEvent('component_pressed', {
      component: {
        type: 'button',
        name: 'profile search linkout',
      },
      displayLanguage: language,
      zone,
    });
  };

  return (
    <Box
      component="a"
      id={PEOPLE_SEARCH}
      borderRadius="large"
      overflow="hidden"
      boxShadow="medium"
      href={peopleSearchUrl}
      onClick={trackPeopleSearchClick}
      cursor="pointer"
      display="block"
      maxWidth="xsmall"
    >
      <Columns space="none">
        <Column>
          <Box padding="small" paddingY="gutter">
            <Stack space="small">
              <Text size="standard" weight="strong">
                {t('Search for people')}
              </Text>
              <Text size="small">{t('Find people who...')}</Text>
            </Stack>
          </Box>
        </Column>
        <Column width="content">
          <Box
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              paddingRight: '12px',
            }}
          >
            <CandidatesSVG />
          </Box>
        </Column>
      </Columns>
    </Box>
  );
};
